// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderLocation":"c-m_fp","advertDetailHeaderLocation__value":"c-m_fq"};